import React, { Component } from 'react';
// material
import { withStyles, Theme } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogActions, Checkbox, Hidden } from '@material-ui/core';
import ActionButton from '../../../components/buttonsComponent/ActionButton';
import TextInput from '../../../components/inputs/CustomTextInput';
import { Actions } from '../NextAction';
import SelectInput from '../../../components/inputs/CustomSelectInput';
import { DISPOSITIONS } from '../data';
import { CampaignContact } from '../../../entities/site';

declare global {
  interface Window {
    highlightSyntax(): void;
  }
}

const styles: any = (theme: Theme) => ({
  root: {
    borderRadius: 10
  },
  content: {
    fontFamily: "Roboto",
    padding: "30px !important",
  },
  title: {
    fontFamily: "Roboto",
    fontSize: "26px",
    color: "#627995",
    marginBottom: 40,
    textAlign: 'center'
  },
  messageContainer: {
    backgroundColor: "rgba(0, 171, 202, 0.1)",
    borderRadius: "10px",
    color: "#00ABCA",
    padding: "16px 20px",
    marginBottom: 40,
    fontSize: "16px",
  },
  footerContainer: {
    padding: "20px",
    backgroundColor: " #E5F7FA",
    color: "#627995",
    fontSize: "16px",
    textAlign: "center",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      textAlign: "left",
    }
  },
  label: {
    fontFamily: "Roboto",
    color: "#627995"
  },
  fieldContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
    paddingLeft: 20
  },
  field: {
    width: "75%"
  },
  actionRoot: {
    padding: 0,
    paddingTop: 52,
    paddingBottom: 9,
  }
})

interface ModalProps {
  title: string;
  open: boolean;
  action: Actions;
  width?: number;
  classes: any;
  message?: string;
  contact: CampaignContact;
  primaryActionCallback: (data: any) => void;
  onClose(data?: any): void;
}

const CallModal: React.FC<ModalProps> = (props) => {
  const { classes, title, primaryActionCallback, onClose, contact, message, action } = props;
  const [checked, setChecked] = React.useState(true);

  const [textMessage, setTextMessage] = React.useState<string>("");
  const [disposition, setDisposition] = React.useState<string>(contact.disposition ?? '');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleAction = () => {
    if (props.action === Actions.text || props.action === Actions.note) {
      primaryActionCallback({ id: contact.id, message: textMessage, action: props.action, disposition })
    } else {
      primaryActionCallback({ id: contact.id, action: props.action, disposition })
    }
  };

  return (
    <Dialog open={props.open} classes={{ paper: classes.root }} onClose={onClose} maxWidth="md">
      <DialogContent classes={{ root: classes.content }} >
        <div className={classes.title}>{title}</div>
        {message && <div className={classes.messageContainer}>{message}</div>}
        {(action === Actions.note || action === Actions.text) ?
          <TextInput rows={7} multiline type="string" result={textMessage} onChange={(event: any) => setTextMessage(event.target.value)} /> :
          <>
            <div className={classes.fieldContainer}>
              <span className={classes.label}>Name</span>
              <div className={classes.field}>
                <TextInput type="string" result={`${contact.firstName} ${contact.lastName}`} onChange={() => { console.log("Clicked") }} />
              </div>
            </div>
            <div className={classes.fieldContainer}>
              <span className={classes.label}>Phone</span>
              <div className={classes.field}>
                <Hidden smDown>
                  <TextInput type="string" result={contact.phoneNumber} onChange={() => { console.log("Clicked") }} />
                </Hidden>
                <Hidden smUp>
                  <div style={{paddingTop: 10, paddingBottom: 10}}>
                    <a href={`tel:${contact.phoneNumber}`}>Call {contact.phoneNumber}</a>
                  </div>
                </Hidden>
              </div>
            </div>
            <div className={classes.fieldContainer}>
              <span className={classes.label}>Disposition</span>
              <div className={classes.field}>
                <SelectInput value={disposition} fullWidth values={DISPOSITIONS} onChange={(event)=>setDisposition(event.target.value)}/>
              </div>
            </div>
          </>
        }
        <DialogActions classes={{ root: classes.actionRoot }}>
          <ActionButton onClick={onClose} type='secondary'>Cancel</ActionButton>
          <ActionButton onClick={handleAction}>{title}</ActionButton>
        </DialogActions>
      </DialogContent>
      <div className={classes.footerContainer}>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          size="small"
        />
        <span>Please &nbsp;<b>automatically</b>&nbsp; advance to the next person on my Next Action list</span>
      </div>

    </Dialog>
  )

}
export default withStyles(styles)(CallModal) 


// WEBPACK FOOTER //
// ./src/pages/next-action/Modal/index.tsx